/**
 * PATH: packages/ui/src/kanban/components/card-detail/shared.ts
 * FILE_ID: UI-KANBAN-UTL-110
 * PURPOSE: Tiny pure helpers shared by drawer sections.
 * WHY: Split from the 4,176-line CardDetailDrawer monolith (UAT P5).
 *      Verbatim move - behaviour unchanged; the host re-exports the
 *      public surface so existing imports keep working.
 */

import { formatDmyTime } from '../../utils/localDate'

/**
 * Drawer date+time stamp. Day-first `dd/mm/yyyy, HH:mm` so activity rows,
 * the "updated" line and comments all read unambiguously (operator ask
 * 2026-06-29: "dates should be dd/mm/yyyy"). Returns an em-dash for empty
 * input; never throws.
 */
export function formatDateTime(iso: string | null): string {
  if (!iso) return '—'
  return formatDmyTime(iso) || '—'
}

